import React from 'react';

import { Progress } from 'antd';

import styles from './GiideWithStep.module.css';
import useAudioUpload from './Hooks/useAudioUpload';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AudioLibraryUploadingItem: React.FC = () => {
  const { audioUploadProgress, audioUploadFileName } = useAudioUpload();

  return (
    <>
      <li key="uploading item" className={styles.emptyLibraryItemWrapper}>
        <div className={styles.placeholderItem}>
          <FontAwesomeIcon
            icon={faPlay}
            className={styles.disabledPlayOnUpload}
          />
          <div className={styles.placeholderMainArea}>
            {audioUploadFileName}
            <div className={styles.placeholderLarge} />
          </div>
          <div className={styles.placeholderSmall} />
          <div className={styles.placeholderSmall} />
          <Progress
            percent={audioUploadProgress}
            strokeWidth={26.5}
            showInfo={false}
            strokeColor="#35baa4"
            className={styles.audioUploadProgress}
          />
        </div>
      </li>
    </>
  );
};

export default AudioLibraryUploadingItem;
